<!--
 * @Author: Penk
 * @LastEditors: Penk
 * @LastEditTime: 2023-10-09 13:39:06
 * @FilePath: \vue-chrome-ext-demo\src\components\hello.vue
-->
<template>
  <div>
    <a href="https://www.qq.com">个人主页</a>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data() {
    return {
    }
  },
}
</script>

<style scoped>
.hello {
  text-align: center;
}

img {
  width: 100px;
  height: 100px;
}
</style>